// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__6hs-a","fade-in":"layout_fade-in__hZEra"};